<template>
  <div class="userCenter">
    <van-nav-bar :fixed="true" title="连续劳务个税计算器" />
    <section class="main-content">
        <div class="banner"> 
            <img src="@/assets/images/banner.png" />
            <div @click="seeTax" class="btn">
                查看个税依据>
            </div>
        </div>
        <div class="content">
            <van-tabs v-model="active" 
                title-active-color="#FEFR43" 
                color="#FEFR43">
                <van-tab title="每月收入不固定">
                  
                </van-tab>
                <van-tab title="每月收入固定">
                   
                </van-tab>
            </van-tabs>
            <section class="tax-content">
                <div class="fixed-content" v-if="active===1">
                    <van-field 
                    type="number"
                    v-model="fixedMonth" 
                    label-width="0"  
                    @input="onFixedAmountInput($event)"
                    @blur="formatFixedAmount"
                    max = "98000"
                    min = "0"
                    placeholder="请输入金额" >
                            <template #button>
                                <span class="dan">元</span>
                            </template>
                    </van-field>
                </div>
                <p class="tip">
                    请输入每月税前收入金额，月收入不超过98000元
                </p>

            <van-row v-if="active===0" class="tax-month" gutter="8">
                    <van-col span="12" v-for="item in dataList" :key="item.month">
                        <van-field 
                        type="number"
                        @input="onAmountInput(item, $event)"
                        @blur="formatAmount(item)" 
                        v-model="item.amount" 
                        label-width="46" 
                        max = "98000"
                        min = "0" 
                        placeholder="请输入金额" >
                            <template #label>
                                <span class="label">{{item.month}}月</span>
                            </template>
                        </van-field>
                    </van-col>
        
            </van-row>
            <div class="tax-month-fixed"  v-if="active===1">
                <div class="header-top">
                    <span>
                        选择月份
                    </span>
                    <van-checkbox checked-color="#326cf0" shape="square"  v-model="checkedAll">全选</van-checkbox>
                </div>
                   <van-row class="tax-month" gutter="8">
                    <van-col span="8" v-for="item in dataList" :key="item.month">
                       <span @click="checkMonth(item)" :class="{active:item.checked}" class="month-item">
                            {{item.month}}月
                            <img src="@/assets/images/selected.png" v-if="item.checked" class="checkbox-img">
                       </span>
                    </van-col>
        
            </van-row>
            </div>
            </section>
            <van-row class="footer-row" :gutter="active===0?8:0">
                <van-col span="12" v-if="active===0">
                    <van-button type="primary" class="reset" block  @click="reset">重置</van-button>
                </van-col>
                <van-col :span="active===0?12:24">
                        <van-button type="primary" class="js" block color="#326cf0" @click="submitForm">计算</van-button>
                </van-col>
             </van-row>
        </div>
     
    </section>
    
 
  </div>
</template>
<script>
import jobHeaderSimple from "@/components/header/header.vue";
import { CheckboxGroup,Checkbox,Field,Tabs,Tab,NavBar,Image, Cell, CellGroup, Button, Icon, Row, Col, Popup } from 'vant'
import api from '@/api/list'
import { mapGetters } from 'vuex'
import { getToken } from '@/utils/auth'
export default {
  components: {
    [CheckboxGroup.name]: CheckboxGroup,
    [Checkbox.name]: Checkbox,
    [Field.name]: Field,
    [Tabs.name]: Tabs,
    [Tab.name]: Tab,
    [NavBar.name]: NavBar,
    [Image.name]: Image,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Button.name]: Button,
    [Icon.name]: Icon,
    [Row.name]: Row,
    [Col.name]: Col,
    [Popup.name]: Popup,
    jobHeaderSimple
  },
  data() {
    return {
        active:0,
        checkedAll:false,
        fixedMonth:null,//固定月份的金额
        dataList:[
            {
                month:1,
                amount:null,
                checked:false
            },
            {
                month:2,
                amount:null,
                checked:false
            },
            {
                month:3,
                amount:null,
                checked:false
            },
              {
                month:4,
                amount:null,
                checked:false
            },
                {
                month:5,
                amount:null,
                checked:false
            },
            {
                month:6,
                amount:null,
                checked:false
            },
            {
                month:7,
                amount:null,
                checked:false
            },
              {
                month:8,
                amount:null,
                checked:false
            },
                {
                month:9,
                amount:null,
                checked:false
            },
            {
                month:10,
                amount:null,
                checked:false
            },
            {
                month:11,
                amount:null,
                checked:false
            },
              {
                month:12,
                amount:null,
                checked:false
            }
        ]
    }
  },
    watch: {
        checkedAll: {
        handler(newVal) {
            // 只有当全选状态真正改变时才更新所有项目
            if (newVal !== this.isAllChecked()) {
            this.dataList.forEach(item => {
                item.checked = newVal;
            });
            }
        }
        }
    },
  computed: {
    ...mapGetters(['userInfo', 'mobileDefaultAvatar']),
  },
  async created() {
   
  },
  methods: {
    formatNumber(value) {
        if (value === null || value === '') {
        return '';
        }
          // 转换为数字
    const num = parseFloat(value);
    if (isNaN(num)) {
        return value;
    }
    
    // 检查原始值是否包含小数点
    const strValue = value.toString();
    if (strValue.includes('.')) {
        // 如果包含小数点，保留原有的小数位数
        const decimalPlaces = strValue.split('.')[1].length;
        return new Intl.NumberFormat('en-US', {
            minimumFractionDigits: decimalPlaces,
            maximumFractionDigits: decimalPlaces
        }).format(num).replace(/,/g, ',');
    } else {
        // 整数不显示小数点
        return new Intl.NumberFormat('en-US', {
            maximumFractionDigits: 0
        }).format(num).replace(/,/g, ',');
    }
      // 使用正则表达式来添加千位分隔符
        // return new Intl.NumberFormat().format(value);
    },
      // 通用的金额输入限制方法
  validateAmountInput(value) {
    // 允许的输入模式：
    // 1. 空字符串
    // 2. 纯数字
    // 3. 数字后跟一个小数点
    // 4. 数字.数字（小数点后最多两位）
    const validPattern = /^(\d*\.?\d{0,2}|\d+\.?)$/;
    
    // 防止多个小数点
    const decimalPoints = (value.match(/\./g) || []).length;
    
    return value === '' || (validPattern.test(value) && decimalPoints <= 1);
  },
  
  // 通用的金额格式化方法（不四舍五入，直接截取）
  formatAmountValue(value) {
    if (value && value !== '') {
      const num = parseFloat(value);
      if (!isNaN(num)) {
        if (Number.isInteger(num)) {
          return num.toString();
        } else {
          const str = num.toString();
          if (str.includes('.')) {
            const parts = str.split('.');
            const integerPart = parts[0];
            const decimalPart = parts[1].substring(0, 2); // 直接截取前两位小数
            
            if (decimalPart === '' || decimalPart === '00' || decimalPart === '0') {
              return integerPart;
            } else {
              return integerPart + '.' + decimalPart;
            }
          } else {
            return str;
          }
        }
      }
    }
    return '';
  },
    // 限制金额输入为最多两位小数
    onAmountInput(item, value) {
      if (this.validateAmountInput(value)) {
        item.amount = value;
      }
    },
  
    // 失去焦点时格式化金额，不四舍五入，直接截取
    formatAmount(item) {
        item.amount = this.formatAmountValue(item.amount);
    },
      // 限制固定金额输入为最多两位小数
    onFixedAmountInput(value) {
        if (this.validateAmountInput(value)) {
        this.fixedMonth = value;
        }
    },
     // 失去焦点时格式化固定金额
    formatFixedAmount() {
        this.fixedMonth = this.formatAmountValue(this.fixedMonth);
    },
        // 检查是否所有项都被选中
    isAllChecked() {
      return this.dataList.every(item => item.checked);
    },
        checkMonth(item){
        item.checked = !item.checked;
        // 更新全选状态
      this.$nextTick(() => {
        this.checkedAll = this.isAllChecked();
      });
    },
    //重置
    reset(){
        this.dataList.map((item) => {
            item.amount = null
        })
    },
    //计算
    submitForm(){
        let requestData = {};
        if (this.active === 1) {
            // 当 active 为 1 时，使用固定月份金额
            if (!this.fixedMonth) {
                this.$toast('请输入固定金额');
                return;
            }
            // 验证金额是否超过限制
           if (parseFloat(this.fixedMonth) <= 0 || parseFloat(this.fixedMonth) > 98000) {
                this.$toast('月收入金额必须在0-98000元之间');
                return;
            }
            
            // 获取选中的月份
            const selectedMonths = this.dataList.filter(item => item.checked)
                .map(item => item.month);
                
            if (selectedMonths.length === 0) {
                this.$toast('请选择至少一个月份');
                return;
            }
            
            requestData = {
                type: 1, // 固定收入类型
                monthlyData: selectedMonths.map(month => ({
                    month: month,
                    amount: parseFloat(this.fixedMonth)
                }))
            };
        } else {
            // 当 active 为 0 时，使用每月不同收入
            const nonZeroData = this.dataList.filter(item => item.amount && item.amount!== '');
            
            if (nonZeroData.length === 0) {
                this.$toast('请至少输入一个月的收入');
                return;
            }
            
            // 验证每个金额是否超过限制
            for (let item of nonZeroData) {
                 const amount = parseFloat(item.amount);
                 if (amount <= 0 || amount > 98000) {
                    this.$toast(`${item.month}月收入金额必须在0-98000元之间`);
                    return;
                }
            }
            
            requestData = {
                type: 0, // 不固定收入类型
                monthlyData: nonZeroData.map(item => ({
                    month: item.month,
                    amount: parseFloat(item.amount)
                }))
            };
        }
        this.$router.push({
            path: '/servicesTaxResult'
        });
        console.log(requestData,'llll')
          this.$store.commit('SET_TAX_RESULT', JSON.stringify(requestData))
    
    },
    seeTax(){
        this.$router.push({
            path: '/servicesTaxNote',
        })
    },
    getName(data, type, limit) {
      let str = ''
      if (type == '0') {
        if (data === 0) {
          str = '个人'
          if (limit && limit == 1) {
            str = '个人/服务商'
          }
        }
        if (data === 1) {
          str = '企业'
        }
        if (str == '') {
          str = '无预缴'
        }
      } else {
        let arr = data ? data.split(',') : []
        arr.map((item) => {
          if (parseInt(item) == 0) {
            if (str.length === 0) {
              str += '固定'
            } else {
              str += '/固定'
            }
          }
          if (parseInt(item) == 1) {
            if (str.length === 1) {
              str += '专项附加'
            } else {
              str += '/专项附加'
            }
          }
        })
        if (str == '--') {
          str = '无预缴'
        }
      }

      return str
    },

    getActiveUserAllInfoInit() {
      return new Promise((resolve, reject) => {
        if (this.userInfo && this.userInfo.id) {
          resolve(this.userInfo)
        } else {
          if (getToken()) {
            api
              .getActiveUserAllInfo()
              .then((res) => {
                if (res.data.status == '200') {
                  let user = res.data.data
                  this.$store.commit('SET_USER_INFO', user)
                  resolve(user)
                }
              })
              .catch((error) => {
                reject(error)
              })
          } else {
            resolve('')
          }
        }
      })
    },
    //证件照片相关方法
    uploadIdCard() {
      let that = this
      let frontUrl = ''
      let backUrl = ''
      if (
        that.userInfoData.front != null &&
        that.userInfoData.front != '' &&
        that.userInfoData.front != undefined
      ) {
        frontUrl = process.env.VUE_APP_FILE_PATH + that.userInfoData.front
      }
      if (
        that.userInfoData.back != null &&
        that.userInfoData.back != '' &&
        that.userInfoData.back != undefined
      ) {
        backUrl = process.env.VUE_APP_FILE_PATH + that.userInfoData.back
      }
      this.$router.push({
        path: 'editPapers',
        query: {
          papersType: that.userInfoData.papersType,
          username: that.userInfoData.username,
          frontUrl: frontUrl,
          backUrl: backUrl,
        },
      })
    },

    getPaperType() {
      api.getDataDictList({ group: 'papersType' }).then((response) => {
        this.papersTypeOptions = response.data.data
      })
    },
    toContractList() {
      this.$router.push({ path: '/contractList' })
    },
    resetTel() {
      this.$router.push({
        path: '/resetTel',
      })
    },

    editResume() {
      this.$router.push({
        path: '/editResume',
      })
    },
    initCompanyInfos() {
      api.getEOCompany().then((res) => {
        if (res.data.status == '200') {
          this.outsourcing_company = res.data.data.ocompany
          this.expatriate_company = res.data.data.ecompany
          this.specialDeduction = res.data.data.isSpecialDeduction
        }
      })
    },
    toPrivacy(path) {
      this.$router.push({
        path: path,
      })
    },
  },
}
</script>

<style lang="less" scoped>

.userCenter {
    .main-content{
        width: 100%;
        padding: 0 12px;
        box-sizing: border-box;
        /deep/.footer-row{
            margin-bottom: 20px;
        }

        /deep/.tax-month{
           padding-top: 8px;
           padding-bottom: 8px;
           .month-item{
            display: block;
            width: 100%;
            height: 40px;
            line-height: 40px;
            text-align: center;
            font-family: SourceHanSansSC-Medium;
            font-size: 12px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 40px;
            letter-spacing: 0px;
            color: #222222;
            background-color: #fff;
            border-radius: 12px;
            border: solid 1px #c5dbff;
            margin-bottom: 12px;
            &.active{
                  background-color: #e4eefe;
                  position: relative;
            }
            .checkbox-img{
                position: absolute;
                right: -6px;
                top: -6px;
                width: 15px;

            }
           }
        }
        /deep/.van-tab{
           	font-family: SourceHanSansSC-Medium;
            font-size: 14px;
            font-weight: normal;
            font-stretch: normal;
            line-height:18px;
            letter-spacing: 0px;
            color: #333333;
            &.van-tab--active{
                font-weight: bold;
            }
        }
        /deep/.van-tabs__line{
            width: 20%;
            background-color: #6986f7;
        }
        .banner{
            margin-top: 12px;
            position: relative;
            img{
                width: 100%;
            }
            .btn{
                background:url("~@/assets/images/btn.png") center center no-repeat;
                width: 117px;
                height: 23px;
                background-size: contain;
                position: absolute;
                bottom: 9px;
                right: -1px;
                font-family: SourceHanSansSC-Medium;
                font-size: 14px;
                font-weight: normal;
                font-stretch: normal;
                line-height: 23px;
                letter-spacing: 0px;
                color: #ffffff;
                text-align: center;
                padding-left: 8px;
                box-sizing: border-box;
            }
        }
        .content{
            margin-top: 6px;
            background: #ffffff;
            border-radius: 8px;
            padding: 8px;
        }
        .tax-content{
            margin-top: 16px;
                .header-top{
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    font-family: SourceHanSansSC-Medium;
                    font-size: 14px;
                    font-stretch: normal;
                    line-height: 18px;
                    letter-spacing: 0px;
                    color: #333333;
                    height: 33px;
                 }
            .fixed-content{
                 /deep/.van-field{
                    height: 44px;
                    padding-left: 8px;
                 }
                 .dan{
                    font-family: SourceHanSansSC-Bold;
                    font-size: 14px;
                    font-weight: bold;
                    font-stretch: normal;
                    line-height: 36px;
                    letter-spacing: 0px;
                    color: #333333;
                    
                 }
             
            }
            .tip{
                font-family: SourceHanSansSC-Regular;
                font-size: 12px;
                font-weight: normal;
                font-stretch: normal;
                line-height: 26px;
                letter-spacing: 0px;
                color: #333333;
                height: 26px;
                background-color: #e4eefe;
                border-radius: 1px;
                width: 100%;
                text-align: center;
                margin-bottom: 12px;
            }
            /deep/.van-field{
                height: 40px;
                border-radius: 6px;
                border: solid 1px #c5dbff;
                padding: 3px 6px 1px 4px;
                margin-bottom: 12px;
            }
            /deep/.van-field__body{
                height: 100%;
              .van-field__control{ 
                    font-family: SourceHanSansSC-Medium;
                    font-size: 12px;
                    font-weight: bold;
                    font-stretch: normal;
                    letter-spacing: 0px;
                    color: #333333;
                    &::placeholder{
                        color: #999;
                    }
                }
            }
            /deep/.van-field__label{
                margin-right: 0;
            }
            .label{
                font-family: SourceHanSansSC-Medium;
                font-size: 12px;
                font-weight: bold;
                font-stretch: normal;
                line-height: 30px;
                text-align: center;
                letter-spacing: 0px;
                color: #ffffff;
                display: block;
                width: 32px;
                height: 32px;
                background-image: linear-gradient(90deg, 
                    #7ea4fa 0%, 
                    #2e69ef 99%), 
                linear-gradient(
                    #83b5ff, 
                    #83b5ff);
                background-blend-mode: normal, 
                    normal;
                border-radius: 4px;
            }
         
        }
           /deep/.reset{
                background-color: #e4eefe;
                font-family: SourceHanSansSC-Medium;
                font-size: 16px;
                font-weight: normal;
                font-stretch: normal;
                letter-spacing: 0px;
                color: #326cf0;
                border-color: #326cf0;
                border-radius: 6px;
            }
            /deep/.js{
                font-family: SourceHanSansSC-Medium;
                font-size: 16px;
                font-weight: normal;
                font-stretch: normal;
                letter-spacing: 0px;
                border-radius: 6px;
            }
    }
 
}
</style>
